import { EPopupGroupActions } from '@r1-frontend/entities/ConnectDomruPopup/context/constants/actions';
import { IRequestResult } from '@r1-frontend/entities/ConnectDomruPopup/context/initialState';

import { IAction } from '@r1-frontend/shared/types/Redux';

export const setResult = (result: IRequestResult): IAction<EPopupGroupActions.SetResult, { result: IRequestResult }> => ({
    type: EPopupGroupActions.SetResult,
    payload: {
        result,
    },
});
